import "../../../assets/scss/components/sections/home/cta.scss";
import { Col, Container, Image, Row } from "react-bootstrap";

import ctaImg from "../../../assets/images/home/cta-img.png";
import check from "../../../assets/images/home/benefits-check.svg";
import Btn from "../../templates/button";

import shape1 from "../../../assets/images/home/cta-shape.svg";
const CTA = () => {
  const data = [
    {
      heading: "Boost Efficiency",
      paragraph: "Apply to more jobs in less time",
    },
    {
      heading: "Enhance Applications",
      paragraph: "Stand out with tailored resumes and cover letters",
    },
    {
      heading: "Increase Confidence",
      paragraph: "Ace interviews with real-time AI feedback",
    },
    {
      heading: "Measure Success",
      paragraph: "Track progress with actionable metrics",
    },
  ];
  return (
    <div className="cta-section">
      <Container>
        <div className="cta">
          <div className="content d-flex justify-content-between">
            <Row className="align-items-center">
              <Col lg={6}>
                <div className="left">
                  <div className="heading text-start">
                    <h3 className="heading-3">
                      Create a Job-Winning Resume and Cover Letter With AI
                    </h3>
                    <p className="paragraph-small-regular">
                      Perfect resumes and cover letters designed for today’s job
                      market
                    </p>
                  </div>
                  <div className="features-list">
                    {data.map((d, index) => (
                      <div className="list-item" key={index}>
                        <div className="list-top">
                          <div className="check">
                            <div className="icon">
                              <Image src={check} />
                            </div>
                          </div>
                          <h6 className="heading-6">{d.heading}</h6>
                        </div>
                        <div className="list-item-text">
                          <p className="paragraph-small-regular">
                            {d.paragraph}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="text-center text-lg-start">
                    <Btn
                      text="Get Started"
                      class="btn-primary"
                      handle={() => {
                        window.location.href =
                          process.env.REACT_APP_APP_REGISTER_URL;
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="right">
                  <Image src={ctaImg} />
                  <div className="shape-1 shape">
                    <Image src={shape1} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CTA;
